import React, { useContext, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, Modal, Col, Row, Card, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/SaveRounded";
import ApiAuth from "../../../core/api/api.auth";
import ContextApp from "../../../core/contexts/context.app";
import SwalMessage from "./SwalMessage";

const ChangePassword = () => {
  const ctx = useContext(ContextApp);
  const {
    register: register,
    handleSubmit: handleSubmit,
    control: control,
    formState: { errors: errors, isSubmitting },
    reset: reset,
    getValues: getValues,
    setValue: setValue,
  } = useForm({ defaultValues: { id: 0 } });

  const onSubmit = async (data) => {
    try {
      // data.phoneNumber = data.phoneNumber.replaceAll(" ", "");
      const response = await ApiAuth.changePassword(data);
      if (response.succeeded == true) {
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } else SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      // history.goBack();
    } catch (error) {
    }
  };

  return (
    <div className={`card card-custom`}>
      {/* Start Box Header */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label font-weight-bolder text-dark">فرم تغییر رمزعبور</span>
          <span className="text-muted mt-3 font-weight-bold font-size-sm">فرم زیر را تکمیل کنید.</span>
        </h3>
        <div className="card-toolbar"></div>
      </div>

      {/*Start body */}

      <div className="card-body pt-3 ">
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Row className=" border-top">
            <Col lg="3" xs="12">
              <Controller
                name="oldPassword"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="رمز عبور قدیم"
                    type="password"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onInput={onChange}
                    autoComplete="false"
                  />
                )}
              />
              {errors.oldPassword && <small className="text-danger">لطفا رمز عبور قدیم را وارد نمایید</small>}
            </Col>
          </Row>
          <Row>
            <Col lg="3" xs="12">
              <Controller
                name="password"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="رمز عبور جدید"
                    type="password"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onInput={onChange}
                    autoComplete="false"
                  />
                )}
              />
              {errors.password && <small className="text-danger">لطفا رمز عبور جدید را وارد نمایید</small>}
            </Col>
          </Row>
          <Row>
            <Col lg="3" xs="12">
              <Controller
                name="confirmPassword"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="تکرار رمز عبور جدید"
                    type="password"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onInput={onChange}
                    autoComplete="false"
                  />
                )}
              />
              {errors.confirmPassword && <small className="text-danger">لطفا تکرار رمز عبور جدید را وارد نمایید</small>}
            </Col>
          </Row>
          <Row>
            <Col lg="3" xs="12" className="mt-2">
              <Button variant="success" type="submit" disabled={isSubmitting} className="w-100">
                {isSubmitting && <Spinner animation="border" variant="warning" />}
                <SaveIcon /> ثبت
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
